module.exports = require("core-js/modules/esnext.set.is-subset-of.js");